export default __webpack_public_path__ + "static/media/ssl_3.e2ef401e.PNG";